<template>
  <div>
    <drag
      v-for="(element, i) in unassignedPeople"
      :key="i" class="drag"
       :transferData="{ person: element }" >
      <person :label="element.name" :active="element.active !== undefined"/>
    </drag>
  </div>
</template>

<script>
import Person from "./Person.vue";
import { Drag } from "vue-drag-drop";

export default {
  name: "travelers",
  components: {
    Person,
    Drag
  },
  props: {
    travelers: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
    };
  },
  mounted: function() {
    //nothing yet
  },
  methods: {
  },
  computed: {
    unassignedPeople: function() {
      let filtered = this.travelers.filter(item => !item.assigned);

      return filtered;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.drag {
  cursor: grab;
}

.dragging {
  cursor: grabbing;
}
</style>
